import { useContext } from 'react';
import { PageTitleContext } from './PageTitleProvider';

function PageTitle({ title }) {
  const { setPageTitle } = useContext(PageTitleContext);
  setPageTitle(title);
  return null;
}

export default PageTitle;
